/**
 * @module Commands/CommandsBulkUpload
 * @summary This module exports the CommandsBulkUpload component
 */

import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import {
  Button,
  CircularProgress,
  Typography,
  Grid,
  DialogTitle,
  DialogContent
} from '@material-ui/core'
import FileSaver from 'file-saver'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ConfirmationalDialog from '../../common/ConfirmationDialog'


// calling server for updation
const UPLOAD_EXCEL_FILE = gql`
  mutation excelFileUpload(
    $fileInfo: FileUploadInput!
    $commonInput: CommonInput!
  ) {
    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {
      failedToUpload
      totalExcelDataRecords
      totalDuplicateRecords
      successfullyUploaded
      failedUploadList
    }
  }
`

const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

const modalStyle = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  p: 4,
  backgroundColor: '#ffffff'
}

class BulkUpload extends Component {
  state = {
    fileName: '',
    bucketName: '',
    publicUploadURL: '',
    isUploading: false,
    uploadSucess: false,
    uploading: false,
    failedRecords: 0,
    uploadedFileName: '',

    response: '',
    uploadErrors: false,
    failList: [],
    selectedAlertType: '',
    fileFormatValid: '',
    isSubmitBulkUpload : false
  }

  /**
   * @summary The columns of the Error table
   */
  errorTableColumns = ['Vehicle Number', 'Reason']

  /**
   * @summary The options for the Error table
   */
  errorTableOptions = {
    selectableRows: 'none',
    responsive: 'stacked',
    rowsPerPage: 5,
    print: false,
    download: true
  }

  handleSubmit = async () => {
    this.setState({ uploading: true, isSubmitBulkUpload : false })

    const response = await this.props.client.mutate({
      mutation: UPLOAD_EXCEL_FILE,

      variables: {
        fileInfo: {
          uploadFor: 'vehicleCommandsBulk',
          bucketName: this.state.bucketName,
          fileName: this.state.fileName
        },
        commonInput: {}
      },
      errorPolicy: 'all'
    })

    if (response.data && response.data.excelFileUpload) {
      const fullData = []
      const sucessfulEntries =
        response.data.excelFileUpload.successfullyUploaded
      const failedEntries = response.data.excelFileUpload.failedUploadList

      const failedToUpload = response.data.excelFileUpload.failedToUpload

      JSON.parse(failedEntries).forEach(element => {
        var rowData = []
        rowData.push(element.vehicleNumber)
        rowData.push(element.error)
        fullData.push(rowData)
      })

      this.setState({
        fileFormatValid: '',
        response:
          'Total Excel Records= ' +
          response.data.excelFileUpload.totalExcelDataRecords +
          ', Total Records Uploaded=' +
          response.data.excelFileUpload.successfullyUploaded +
          // ', Total Duplicate Records=' +
          // response.data.excelFileUpload.totalDuplicateRecords +
          ', Total Records Failed To Upload=' +
          response.data.excelFileUpload.failedToUpload,
        uploadSucess: true,
        uploading: false,
        failList: fullData,
        failedRecords: response.data.excelFileUpload.failedToUpload,
        bucketName: '',
        fileName: '',
        publicUploadURL: '',
        uploadedFileName: ''
      })

      if (response.data.excelFileUpload.failedToUpload != 0) {
        this.setState({
          uploadErrors: true,
          failList: fullData,
          uploading: false,
          bucketName: '',
          fileName: '',
          publicUploadURL: '',
          uploadedFileName: ''
        })
      }
    } else if (response.data == null && response.errors) {
      this.setState({
        fileFormatValid: response.errors[0].message,
        response: '',
        uploadErrors: false,
        uploading: false,
        bucketName: '',
        fileName: '',
        publicUploadURL: '',
        uploadedFileName: ''
      })
    } else {
    }
  }
 

  /**
   * @summary Fetches a url for uploading a file and uploads the file
   */
  onUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    this.setState({ isUploading: true })
    if (validity.valid && file) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })

      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        await axios.put(url, file, {
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type || "application/octet-stream"
          }
        })
        this.setState({
          fileName: response.data.getPublicUploadURL.filename,
          bucketName: response.data.getPublicUploadURL.bucketName,
          publicUploadURL: response.data.getPublicUploadURL.publicUploadURL,
          uploadedFileName: file.name
        })
      }
    }
    this.setState({ isUploading: false })
  }

  handleDownload = async () => {
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'vehicleCommandsTemplate.xlsx'
      },
      errorPolicy: 'all'
    })
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })
    FileSaver.saveAs(new Blob([res.data]), 'vehicleCommandsTemplate.xlsx')
  }

  render() {
    return (
      <div style={modalStyle}>
        <ConfirmationalDialog
        isDialogOpen={this.state.isSubmitBulkUpload}
        dialogMessage={'Are you sure to bulk upload the commands?'}
        negativeResponseHandler={this.props.onClose}
        positiveResponseHandler={this.handleSubmit}
      />
        <DialogTitle id="alert-dialog-title">
          <Grid container gutterBottom>
            <Grid item>
              <ArrowBackIcon
                color="primary"
                onClick={this.props.onClose}
                style={{ marginRight: '0.5em' }}
              />
            </Grid>
            <Grid item>
              <Typography variant="h4"> Bulk Upload</Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ maxHeight: '60vh', overflow: 'auto' }}>
          <Grid container gutterBottom>
            <Button
              variant="outlined"
              color="secondary"
              style={{
                border: '1px solid green',
                marginBottom: '1em'
              }}
              onClick={this.handleDownload}
            >
              Download Template
            </Button>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: '2em' }}>
            <Grid item>
              <input
                accept="*/*"
                id="contained-button-file"
                multiple
                type="file"
                style={{
                  display: 'none'
                }}
                onChange={this.onUpload}
              />
              <label htmlFor="contained-button-file">
                <Button variant="outlined" component="span">
                  {this.state.isUploading ? (
                    <CircularProgress size={15} />
                  ) : (
                    'Choose File'
                  )}
                </Button>
              </label>
            </Grid>

            <Grid
              item
              xs={6}
              style={{
                marginLeft: '2%',
                alignSelf: 'center'
              }}
            >
              <Grid container>
                <Grid
                  item
                  style={{
                    maxWidth: '30%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  spacing={3}
                >
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    gutterBottom
                    style={{ textOverflow: 'ellipsis' }}
                  >
                    {this.state.uploadedFileName}
                  </Typography>
                </Grid>
                <Grid item xs={6} spacing={3}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    gutterBottom
                    style={{ marginLeft: '1%' }}
                  >
                    {this.state.uploadedFileName ? ' | ' : ''} File Format -
                    XLS, XLSX
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Button
            onClick={() => {
              if(this.state.isSubmitBulkUpload == false){
                this.setState({isSubmitBulkUpload : true})
              }else{
                this.setState({isSubmitBulkUpload : false})
              }
            }}
            type="submit"
            variant="raised"
            color="secondary"
            disabled={!this.state.fileName || this.state.uploading}
          >
            {this.state.uploading ? <CircularProgress size={15} /> : 'Submit'}
          </Button>
          <div style={{ padding: '1em' }} />
          <Grid item xs={12}>
            {this.state.fileFormatValid && (
              <Typography variant="body2" mt={2} style={{ color: 'red' }}>
                {this.state.fileFormatValid}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            {this.state.failList.length == 0 &&
              this.state.response && (
                <Typography
                  variant="subtitle1"
                  style={{ marginTop: '1em', marginBottom: '1em' }}
                >
                  Succesfully Uploaded
                </Typography>
              )}
          </Grid>

          <Grid item xs={12}>
            {this.state.response && (
              <Typography
                variant="body1"
                style={{
                  color: this.state.failList.length == 0 ? 'green' : 'red'
                }}
              >
                {this.state.response}
              </Typography>
            )}
          </Grid>

          {this.state.uploadErrors > 0 && this.state.failList.length != 0 ? (
            <Grid item style={{ width: '100%' }}>
              <h5>Failed records list</h5>
              <MUIDataTable
                data={this.state.failList}
                columns={this.errorTableColumns}
                options={this.errorTableOptions}
              />
            </Grid>
          ) : (
            <div />
          )}
        </DialogContent>
      </div>
    )
  }
}

export default BulkUpload



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleCommands/BulkUpload.js